import Status from "components/App/Status";
import colors from "constants/palette";
// 0 1 2 3
export const states = [
  {
    title: "در حال پردازش",
    icon: <Status color={colors.yellow} />,
  },
  {
    title: "در حال ارسال",
    icon: <Status color={colors.yellow} />,
  },
  {
    title: "ارسال شده",
    icon: <Status color={colors.green} />,
  },
  {
    title: "مرجوع شده",
    icon: <Status color={colors.red} />,
  },
  {
    title: "لغو شده",
    icon: <Status color={colors.red} />,
  },
];
export const codes = [
  {
    type: "order_addition",
    title: "سفارش جدیدی اضافه شده است",
  },
];
